import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { Link } from "@mui/material";
import logo from "./logo.png";
import { MenuLink, MobileMainMenu, SiteLogo } from "./styles";
import styled from "@emotion/styled";
export default function MobileMenu(props) {
  const [state, setState] = useState({ top: false });
  const Connect = styled.div`
    cursor: pointer;
    background: linear-gradient(to right, #ff3ffd, #fed900);
    text-shadow: 2px 1px 12.9px #ec9dc1;
    background-size: cover;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    border-radius: 24px;
    padding: 10px 20px 10px 0px;
    font-family: "Lucida-Regular";
    font-size: 20px;
    opacity: 1;
    /* box-shadow: ${(props) =>
      props.bs ? props.bs : "inset 0px 2px 5px 0px white"}; */
    &:hover {
      /* color: #000; */
      opacity: 1;
    }
    @media screen and (max-width: 899px) {
      display: none;
    }
  `;
  const A = styled.a`
    text-decoration: none;
  `;
  const WrapperList = styled.div`
    width: 100vw;
    display: block;
    text-align: center;
  `;
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <MobileMainMenu>
      {/* <React.Fragment> */}
      <A href="/">
        {/* <SiteLogo src={logo} /> */}
        {/* <SiteLogo src={logo} /> */}
      </A>

      {state["left"] ? (
        <Button onClick={toggleDrawer("left", false)}>
          <span
            className="material-symbols-outlined"
            style={{ color: "#fff", fontSize: 30 }}
          >
            menu_open
          </span>
        </Button>
      ) : (
        <Button onClick={toggleDrawer("left", true)}>
          <span
            className="material-symbols-outlined"
            style={{ color: "#FFF", fontSize: 30 }}
          >
            menu
          </span>
        </Button>
      )}
      <Drawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        <Box
          sx={{
            width: 1950,
            background: "#000000",
            minHeight: "calc( 100vh - 30px )",
            textAlign: "center",
            paddingTop: "120px",
          }}
          role="presentation"
          // onClick={toggleDrawer("left", false)}
          // onKeyDown={toggleDrawer("left", false)}
        >
          {/* <Link href="/" className="d-inline-block pt-4 pl-4">
              <SiteLogo src={logo} width="100" />
            </Link> */}
          <Divider />
          <WrapperList>
            {props.menuList.map((text, index) => (
              <MenuLink
                key={index}
                href={text[1]}
                className={text[3] + " d-block"}
              >
                {text[0]}
              </MenuLink>
            ))}
          </WrapperList>
        </Box>
      </Drawer>
      {/* </React.Fragment> */}
    </MobileMainMenu>
  );
}
